// Single source of truth for client-side caching policy.
// Rule: JSON API data is ALWAYS fetched fresh (no browser/CDN cache, no stale flash);
// only images are allowed a short cache and are versioned with `?v=` (see img.js).
// Backend counterpart: /app/backend/cache_policy.py — keep both in sync.

export const FRESH_HEADERS = { "Cache-Control": "no-cache, no-store, must-revalidate", Pragma: "no-cache", Expires: "0" };

// Appends a timestamp to GET requests so no intermediary can serve a cached JSON body.
export function applyFreshPolicy(axiosInstance) {
  axiosInstance.defaults.headers.common = { ...axiosInstance.defaults.headers.common, ...FRESH_HEADERS };
  axiosInstance.interceptors.request.use((cfg) => {
    if ((cfg.method || "get").toLowerCase() === "get") cfg.params = { ...(cfg.params || {}), _ts: Date.now() };
    return cfg;
  });
  return axiosInstance;
}

// Image URLs may be cached briefly by the browser; bust with the record's updated_at.
export const IMAGE_VERSION_PARAM = "v";
